var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChanges(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1207 18.0076C14.364 18.2617 14.7609 18.2617 15.0043 18.0076L15.8125 17.1653C16.0562 16.9116 16.0562 16.498 15.8125 16.2443L15.0043 15.4019H26.125C27.1589 15.4019 28 16.2785 28 17.3562C28 17.8949 28.4207 18.3334 28.9375 18.3334H29.5625C30.0793 18.3334 30.5 17.8949 30.5 17.3562C30.5 14.8417 28.5375 12.7963 26.125 12.7963H15.0043L15.8125 11.9539C16.0562 11.7002 16.0562 11.2866 15.8125 11.0329L15.0043 10.1906C14.7609 9.93651 14.364 9.93651 14.1207 10.1906L10.5914 13.8687C10.4695 13.9961 10.4695 14.2021 10.5914 14.3295L14.1207 18.0076Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8793 21.9924C26.6359 21.7383 26.2394 21.7383 25.9957 21.9924L25.1875 22.8348C24.9432 23.0893 24.9428 23.5008 25.1875 23.7557L25.9957 24.5981H14.875C13.841 24.5981 13 23.7215 13 22.6438C13 22.1052 12.5793 21.6667 12.0625 21.6667H11.4375C10.9207 21.6667 10.5 22.1052 10.5 22.6438C10.5 25.1583 12.4625 27.2038 14.875 27.2038H25.9957L25.1875 28.0461C24.9432 28.3007 24.9428 28.7121 25.1875 28.9671L25.9957 29.8095C26.2395 30.0636 26.6355 30.0635 26.8793 29.8095L30.4086 26.1314C30.5304 26.0039 30.5304 25.7979 30.4086 25.6705L26.8793 21.9924Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.5 36.6667C29.7047 36.6667 37.1666 29.2048 37.1666 20C37.1666 10.7953 29.7047 3.33335 20.5 3.33335C11.2952 3.33335 3.83329 10.7953 3.83329 20C3.83329 29.2048 11.2952 36.6667 20.5 36.6667ZM20.5 38.3334C30.6252 38.3334 38.8333 30.1252 38.8333 20C38.8333 9.8748 30.6252 1.66669 20.5 1.66669C10.3747 1.66669 2.16663 9.8748 2.16663 20C2.16663 30.1252 10.3747 38.3334 20.5 38.3334Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChanges);
export default __webpack_public_path__ + "static/media/Changes.f5109aac.svg";
export { ForwardRef as ReactComponent };